import type { GuestDeleteImpact } from "@/types/GuestDeleteImpact";
import type { GuestDeleteImpactTrash } from "@/types/GuestTrash";

// No `trashCopyArgs` (retention days + purge date) any more: since 22.10. the
// trash dialogs ask the plain question and do not spell the retention out.

/**
 * The trash the impact promises, or null. Null means TODAY'S permanent copy —
 * a new FE on a backend without the trash (`trash` absent), or the flag off
 * (`enabled: false`): both must read exactly as before (rollback consistency).
 */
export function trashOf(impact: GuestDeleteImpact | null | undefined): GuestDeleteImpactTrash | null {
  const trash = impact?.trash;
  if (!trash || trash.enabled !== true) return null;
  if (typeof trash.retentionDays !== "number" || !Number.isFinite(trash.retentionDays)) return null;
  return trash;
}
